import React, { Component } from 'react';
import axios from 'axios';
import appConfig from '../../../config.js';
import Table from '../../commons/Table/Table';
import Modal from '../../commons/Modal/Modal';
import { TextInputField, BootstrapSelect, PhoneField } from '../../commons/Inputs';
import FloatingActionButton from '../../commons/Buttons/FloatingActionButton';
import MenuLinks from '../patient/MenuLinks';

let $ = window.jQuery;

export default class Index extends Component {

    state = {
        data: [],
        activeData: [],
        historyData: [],
        headersData: [
            {key : 'name', label : 'Item Name'},
            {key : 'serial', label : 'Serial'},
            {key : 'quantity', label : 'Quantity Remaining'},
            {key : 'amount', label : 'Amount per Item'},
            {key : 'contact_details', label : 'Contact Details'},
            {key : 'clinic', label : 'Clinic'},
            {key : 'actions', label : 'Actions'}
        ],
        headersActive: [
            {key : 'name', label : 'Item Name'},
            {key : 'quantity', label : 'Quantity Remaining'},
            {key : 'amount', label : 'Amount per Item'}
        ],
        headersHistory: [
            {key : 'name', label : 'Item Name'},
            {key : 'used_quantity', label : 'Quantity Used'},
            {key : 'used_amount', label : 'Amount Used per Item'},
            {key : 'total_amount', label : 'Total Amount'}
        ],
        isSavingInventory : false,
        isEditingInventory: false,
        id: '',
        name: '',
        serial: '',
        quantity: '',
        amount: '',
        contact_details: '',
        contact_details_type: 1,
        clinic: '',
        branches: [],
        errors: []
    }

    handleFABClick = () => {
        $('#inventoryModal').modal('show');
    }

    componentDidMount() {
        let self = this;
        $('#amount').inputmask("numeric", {
            radixPoint: ".",
            groupSeparator: ",",
            digits: 2,
            autoGroup: true,
            // prefix: '₱ ',
            rightAlign: false,
            autoUnmask: true,
            max: 999999.99, //max val on api DECIMAL(8, 2)
            oncomplete: (e) => {
                self.setState({
                    amount: e.target.value
                })
            }
        });

        // $('#contact_details').inputmask("text", {
        //     mask: '(9999) 999-9999',
        //     autoUnmask: true,
        //     showMaskOnHover: false,
        //     oncomplete : (e) => {
        //         this.setState({
        //             contact_details : e.target.value,
        //         });
        //     }
        // })
    }

    componentWillMount() {
        this.getAllInventory();
        this.getActiveInventory();
        this.getHistoryInventory();
        this.getBranches();
    }

    getBranches = () => {
        let url = appConfig.apiUrl + 'management/branches';

        axios.get(url).then((res) => {

            let branches = [
                {
                    value: '',
                    label: 'Select Clinic Branch...'
                }
            ];
            res.data.data.forEach((item, i) => {
                let tmp = {
                    value: item.name,
                    label: item.name
                };

                branches.push(tmp);
            });

            this.setState({
                branches
            });

            $('#clinic').selectpicker('refresh');
        });
    };

    generateTableActions(id, active) {
        let actionIcon = 'glyphicon glyphicon-plus';
        let actionTitle = 'Click to activate';

        if(parseInt(active, 10) === 1) {
            actionIcon = 'glyphicon glyphicon-minus';
            actionTitle = 'Click to de-activate';
        }

        let html = (
            <div className="">
                <button href="#"
                        className='btn btn-xs tooltips blue'
                        data-container="body"
                        data-placement="top"
                        data-original-title={actionTitle}
                        onClick={this.handleActivateInventory}
                        data-id={id}>
                    <i className={actionIcon}
                       data-id={id}></i>
                </button>
                <button href="#"
                        className='btn btn-xs tooltips blue'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Edit'
                        onClick={this.handleEditInventory}
                        data-id={id}>
                    <i className='glyphicon glyphicon-edit'
                       data-id={id}></i>
                </button>
                <button href="#"
                        className='btn btn-xs tooltips deletePopover red'
                        data-container="body"
                        data-placement="top"
                        data-original-title='Delete'
                        data-id={id}
                        data-toggle="confirmation"
                        data-singleton="true">
                    <i className='glyphicon glyphicon-remove'
                       data-id={id}></i>
                </button>
            </div>
        )
        return html;
    }

    getAllInventory() {
        let url = appConfig.apiUrl + 'management/dental/inventory';

        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let displayData = res.data.data;
            
            displayData.forEach((row) => {
                row.clinic = (row.clinic === null || row.clinic === "") ? 'No Clinic' : row.clinic;
                row.actions = this.generateTableActions(row.id, row.is_active);
            });

            this.setState({
                data : displayData
            }, (e) => {
                $('#table1').dataTable({
                    'language' : {
                        "emptyTable" : 'No items available'
                    },
                });
                $('.tooltips').tooltip();

                let self = this;

                $('.deletePopover').confirmation({
                    title: 'Are you sure to delete this item?',
                    popout: true,
                    btnOkClass: 'btn btn-primary btn-sm',
                    btnCancelClass: 'btn btn-danger btn-sm',
                    container: 'body',
                    onConfirm: function() {
                        let itemId = $(this).data('id');
                        self.deleteInventory(itemId);
                    }
                });
            });
        }).catch((res) => {
            // display error
        });
    }

    getActiveInventory() {
        let url = appConfig.apiUrl + 'management/dental/inventory/active';

        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let displayData = res.data.data;

            this.setState({
                activeData : displayData
            }, (e) => {
                $('#table2').dataTable({
                    "language": {
                        "emptyTable": "No items available"
                    }
                });
            });
        }).catch((res) => {
            // display error
        });
    }

    getHistoryInventory() {
        let url = appConfig.apiUrl + 'management/dental/inventory/history';

        axios({
            url: url,
            timeout: 20000,
            method: 'get'
        }).then((res) => {
            let displayData = res.data.data;

            displayData.forEach((row) => {
                row.name = row.inventory.name;
            });

            this.setState({
                historyData : displayData
            }, (e) => {
                $('#table3').dataTable({
                    "language": {
                        "emptyTable": "No items available"
                    }
                });
            });
        }).catch((res) => {
            // display error
        });
    }

    handleSaveInventory = () => {
        // disable modal buttons
        this.setState({
            isSavingInventory : true,
        });
        let url = appConfig.apiUrl + (this.state.isEditingInventory ? 'management/dental/inventory/'+this.state.id : 'management/dental/inventory');
        let inventory = $('#inventoryForm').serializeArray();
        inventory.push({name: 'clinic', 'value': this.state.clinic});
        if(this.state.isEditingInventory === true) {
            inventory.push({name: '_method', value: 'PUT'});
        }

        axios({
            url: url,
            timeout: 20000,
            method: 'post',
            data: window.jQuery.param(inventory)
        }).then((res) => {

            // enable modal buttons again
            this.setState({
                isSavingInventory : false
            }, (e) => {
                // destroy table
                $('#table1').dataTable().fnDestroy();
                $('#table2').dataTable().fnDestroy();
                $('#table3').dataTable().fnDestroy();

                // refresh table
                this.getAllInventory();
                this.getActiveInventory();
                this.getHistoryInventory();

                $('.nav-tabs a[href="#itemsPage"]').tab('show');
            });

            // clear form
            this.setState({
                isEditingInventory: false,
            }, (e) => {

                // close modal
                $('#inventoryModal').modal('toggle');
                this.clearForm();
            })
        }).catch((error) => {
            let fields = Object.keys(error.response.data.errors);

            let errors = this.state.errors;
            fields.forEach((item) => {
                errors[item] = true;
            });

            this.setState({
                errors,
                isSavingInventory : false
            });
        });
    }

    handleEditInventory = (e) => {
        let id = parseInt(e.target.dataset.id, 10);
        let index = this.state.data.findIndex((item) => item.id === id);
        let item = this.state.data[index];
        if(item) {
            this.setState({
                isEditingInventory : true,
                id: item.id,
                name: item.name,
                serial: item.serial,
                quantity: item.quantity,
                amount: item.amount,
                contact_details: item.contact_details,
                contact_details_type: item.contact_details_type,
                clinic: item.clinic
            }, (e) => {
                $('#inventoryModal').modal('toggle');
            })
        }
    }

    deleteInventory(id) {
        let url = appConfig.apiUrl + 'management/dental/inventory/'+id;

        axios({
            url: url,
            timeout: 20000,
            method: 'post',
            data: {'_method': 'DELETE'}
        }).then((res) => {

            // destroy table
            $('#table1').dataTable().fnDestroy();
            $('#table2').dataTable().fnDestroy();
            $('#table3').dataTable().fnDestroy();

            // refresh table
            this.getAllInventory();
            this.getActiveInventory();
            this.getHistoryInventory();
        }).catch((res) => {
            // display error
        });
    }

    handleCloseModal = () => {
        this.clearForm();
    }

    clearForm() {
        this.setState({
            isEditingInventory: false,
            id: '',
            name: '',
            serial: '',
            quantity: '',
            amount: '',
            contact_details: '',
            contact_details_type: 1,
            clinic: '',
            errors: []
        });
    }

    handleActivateInventory = (e) => {
        let id = parseInt(e.target.dataset.id, 10);
        let index = this.state.data.findIndex((item) => item.id === id);
        let item = this.state.data[index];
        if(item) {
            let url = appConfig.apiUrl + 'management/dental/inventory/toggle/'+item.id;
            axios({
                url: url,
                timeout: 20000,
                method: 'post',
                data: {}
            }).then((res) => {

                // destroy table
                $('#table1').dataTable().fnDestroy();
                $('#table2').dataTable().fnDestroy();

                // refresh table
                this.getAllInventory();
                this.getActiveInventory();
            }).catch((res) => {
                // display error
            });
        }

    }

    updatePhone = (phone, type) => {
        let contact_details = phone;
        let contact_details_type = type;

        this.setState({
            contact_details,
            contact_details_type
        }, () => {
            console.log("update phone: "+phone+" : "+type)
        })
    }

    render() {
        let menu = [
            {
				link: '#itemsPage',
				label: 'Items'
			},
            {
				link: '#activeItemsPage',
				label: 'Active Items'
			},
            {
				link: '#historyPage',
				label: 'History'
			}
        ];

        return(
            <div className="page-content">

                <div className="row">
                    <div className="col-md-12">
                        <h3 className="page-title">
                            Management &nbsp; <small>Inventory</small>
                        </h3>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="portlet light">
                            <div className="portlet-title tabbable-line">
                                <div className="caption">
                                    <i className=" icon-bar-chart font-blue" />
                                    <span className="caption-subject font-blue sbold uppercase">Inventory</span>
                                </div>
                                <ul className="nav nav-tabs">
                                    {menu.map((item, i) => {
                                        return <MenuLinks {...item} key={i} index={i} />
                                    })}
                                </ul>
                            </div>
                            <div className="portlet-body">
                                <div className="tab-content">
                                    <div className="tab-pane active" id="itemsPage">
                                        <Table id="table1" headers={this.state.headersData} data={this.state.data} />
                                    </div>
                                    <div className="tab-pane" id="activeItemsPage">
                                        <Table id="table2" headers={this.state.headersActive} data={this.state.activeData} />
                                    </div>
                                    <div className="tab-pane" id="historyPage">
                                        <Table id="table3" headers={this.state.headersHistory} data={this.state.historyData} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <FloatingActionButton
                            title="Add Item"
                            onClick={this.handleFABClick} />
                    </div>
                </div>

                <Modal
                    id="inventoryModal"
                    header="Add Item"
                    onNegativeClickEvent={this.handleCloseModal}
                    onPositiveClickEvent={this.handleSaveInventory}
                    isSaving={this.state.isSavingInventory}
                    width="0">

                    <div className="row">
                        <div id="alert-modal-container-clinic" style={{ paddingRight: '20px', paddingLeft: '20px' }}></div>
                        <div className="col-md-12">
                            <form id="inventoryForm">
                                <div className="row">
                                    <div className="col-md-12">
                                        <TextInputField id="name" label="Item name *"
                                                        help=""
                                                        onChange={(e) => {this.setState({name: e.target.value})}}
                                                        val={this.state.name}
                                                        hasError={this.state.errors.name} />
                                        <TextInputField id="serial" label="Serial"
                                                        help=""
                                                        onChange={(e) => {this.setState({serial: e.target.value})}}
                                                        val={this.state.serial} />
                                        <TextInputField id="quantity" label="Quantity *"
                                                        help=""
                                                        onChange={(e) => {this.setState({quantity: e.target.value})}}
                                                        val={this.state.quantity.toString()}
                                                        hasError={this.state.errors.quantity} />
                                        <TextInputField id="amount" label="Amount *"
                                                        help=""
                                                        onChange={(e) => {this.setState({amount: e.target.value})}}
                                                        val={this.state.amount}
                                                        hasError={this.state.errors.amount} />

                                        <PhoneField updatePhone={this.updatePhone}
                                                    val={this.state.contact_details}
                                                    phoneType={this.state.contact_details_type}
                                                    id="contact_details"
                                                    typeId="contact_details_type"
                                                    label="Contact Details"
                                                    help="" />
                                        <BootstrapSelect id="clinic" label="Clinic Branch *"
                                                         help="Select clinic branch..."
                                                         val={this.state.clinic}
                                                         onChange={(e) => {this.setState({clinic: e.target.value})}}
                                                         options={this.state.branches} />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </Modal>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/management/Inventory.js
 **/